const getShiftedOffset = ({ items, offsetId, offset }) => {
  if (offsetId === undefined) {
    return offset;
  }
  const shiftedOffsetIndex = items.findIndex(({ id }) => id === offsetId);

  return shiftedOffsetIndex > -1 ? shiftedOffsetIndex : offset;
};

export default getShiftedOffset;
